import { useMemo } from "react";
// TODO: Uncomment when tab creation functionality is ready for implementation
// import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/shared/ui/tabs";
// import { Button } from "@/shared/ui/button";
// import { Input } from "@/shared/ui/input";
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogFooter,
// } from "@/shared/ui/dialog";
// import { useCreateCategoryTab } from "../../hooks/useCategoryTabs";
// import { Plus } from "lucide-react";
import { cn } from "@/shared/lib/cn";
import type { CategoryTab } from "@/services/api/categories/types";

interface FileExplorerTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  categoryId?: string | number;
  tabs: CategoryTab[];
}

export function FileExplorerTabs({
  activeTab,
  onTabChange,
  tabs: providedTabs,
}: FileExplorerTabsProps) {
  // TODO: Uncomment when tab creation functionality is ready for implementation
  // const createTabMutation = useCreateCategoryTab();
  // const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  // const [newTabLabel, setNewTabLabel] = useState("");
  // const [newTabValue, setNewTabValue] = useState("");

  const allTabs = useMemo(() => {
    if (!providedTabs || providedTabs.length === 0) {
      return [];
    }
    return [...providedTabs].sort(
      (a, b) => (a.order ?? 999) - (b.order ?? 999)
    );
  }, [providedTabs]);

  // TODO: Uncomment when tab creation functionality is ready for implementation
  // const handleAddTab = () => {
  //   if (newTabLabel.trim() && newTabValue.trim() && categoryId) {
  //     const tabValue = newTabValue.trim().toLowerCase().replace(/\s+/g, "-");
  //     createTabMutation.mutate(
  //       {
  //         value: tabValue,
  //         label: newTabLabel.trim(),
  //         categoryId,
  //       },
  //       {
  //         onSuccess: () => {
  //           setNewTabLabel("");
  //           setNewTabValue("");
  //           setIsAddDialogOpen(false);
  //           onTabChange(tabValue);
  //         },
  //       }
  //     );
  //   }
  // };

  if (allTabs.length === 0) {
    return null;
  }

  return (
    <>
      <div className="border-b border-grid-200 bg-white">
        <div className="flex items-center gap-2 px-4 py-2.5">
          {allTabs.length > 0 ? (
            <Tabs
              value={activeTab}
              onValueChange={onTabChange}
              className="flex-1"
            >
              <TabsList className="h-9 bg-transparent p-0 gap-1.5 w-full justify-start">
                {allTabs.map((tab) => (
                  <div
                    key={tab.value}
                    className="relative group flex items-center"
                  >
                    <TabsTrigger
                      value={tab.value}
                      className={cn(
                        "h-8 px-4 text-sm font-medium rounded-md transition-all",
                        "border border-transparent",
                        "data-[state=active]:bg-imperial-50 data-[state=active]:text-imperial-700 data-[state=active]:border-imperial-200",
                        "data-[state=inactive]:text-ink-600 data-[state=inactive]:hover:bg-grid-50 data-[state=inactive]:hover:text-ink-900",
                        "flex items-center gap-2"
                      )}
                    >
                      {tab.label}
                      {/* TODO: Add delete functionality when tab management API is ready */}
                      {/* {tab.id && (
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={(e) => handleRemoveTab(e, tab.id)}
                          className="ml-1.5 h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity rounded-sm hover:bg-imperial-100 p-0"
                          aria-label={`Remove ${tab.label} tab`}
                        >
                          <X className="h-3 w-3" />
                        </Button>
                      )} */}
                    </TabsTrigger>
                  </div>
                ))}
              </TabsList>
            </Tabs>
          ) : (
            <div className="flex-1" />
          )}
          {/* TODO: Uncomment when tab creation functionality is ready for implementation */}
          {/* {categoryId && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsAddDialogOpen(true)}
              className="h-8 px-3 text-sm shrink-0"
              disabled={createTabMutation.isPending}
            >
              <Plus className="h-4 w-4 mr-1.5" />
              Tab
            </Button>
          )} */}
        </div>
      </div>

      {/* TODO: Uncomment when tab creation functionality is ready for implementation */}
      {/* <Dialog open={isAddDialogOpen} onOpenChange={setIsAddDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Add New Tab</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <label className="text-sm font-medium text-ink-700">
                Tab Label
              </label>
              <Input
                placeholder="e.g., My Files"
                value={newTabLabel}
                onChange={(e) => {
                  setNewTabLabel(e.target.value);
                  const autoValue = e.target.value
                    .toLowerCase()
                    .replace(/\s+/g, "-");
                  setNewTabValue(autoValue);
                }}
                autoFocus
              />
            </div>
            <div className="space-y-2">
              <label className="text-sm font-medium text-ink-700">
                Tab Value (URL identifier)
              </label>
              <Input
                placeholder="e.g., my-files"
                value={newTabValue}
                onChange={(e) => setNewTabValue(e.target.value)}
              />
              <p className="text-xs text-ink-500">
                Used in the URL. Lowercase letters, numbers, and hyphens only.
              </p>
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => {
                setIsAddDialogOpen(false);
                setNewTabLabel("");
                setNewTabValue("");
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleAddTab}
              disabled={
                !newTabLabel.trim() ||
                !newTabValue.trim() ||
                !categoryId ||
                createTabMutation.isPending
              }
            >
              {createTabMutation.isPending ? "Creating..." : "Create Tab"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog> */}
    </>
  );
}
